import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Select, Space, Modal, Form } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from "../../js/permission"
import { formItemLayout, tailLayout } from '../../js/globalParam'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type fetchParams = {
    menu_type_name: string | undefined
}

export default function () {

    let posting = false

    let fetchOtherParamsTmpl: fetchParams = {
        menu_type_name: undefined
    }

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [data, setData] = useState<any>([])

    const [id, setID] = useState<string>('')
    const [editVisible, setEditVisible] = useState<boolean>(false)
    const [form] = Form.useForm()

    const [positions, setPositions] = useState<{
        position_number: number,
        position_name: string
    }[]>([])

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        baseAxiosNoInfo('/cooking_center/global/is_cooking_position_list').then((res: any) => {
            res && setPositions(res)
        })
    }, [])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleInputChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        axiosTable.get('/cooking_center/menu_type/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            let p: any = { ...pagination }
            p.total = response.total

            setPagination(p)
            setData(response.records)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const onFinish = (values: any) => {
        if (!posting) {
            posting = true

            let url = id ? '/cooking_center/menu_type/update' : '/cooking_center/menu_type/add'
            baseAxiosComplete.post(url, {
                menu_type_id: id,
                relate_position_number: values.relate_position_number.join(','),
                ...values
            }).then((res: any) => {
                if (res.status === 0) {
                    posting = false

                    resetForm()
                    setEditVisible(false)
                }
            })
        }
    }

    const positionsList = positions.map(el => <Option value={el.position_number.toString()} key={el.position_number}>{el.position_name}</Option>)

    return (<div className="common-page">
        {/* 膳食中心 -> 菜品管理 -> 菜品分类管理 */}
        <BreadCrumb position={['膳食中心', '菜品分类管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="分类名称" value={fetchOtherParams.menu_type_name} onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'menu_type_name') }} />

                {permission.includes('查询') && <Button style={{ marginRight: 5, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch} >查询</Button>}
                <Button style={{ marginRight: 5, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes("添加") && <Button type="primary" style={{ marginRight: 5, marginBottom: 12 }} onClick={() => {
                    setID('');
                    setEditVisible(true)

                    form.setFieldsValue({
                        menu_type_name: undefined
                    })
                }} >添加</Button>}
            </Space>
        </div>

        <div className="common-main">
            <Table dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="menu_type_id" pagination={pagination} onChange={handleTableChange}>
                <Column title="菜品分类" dataIndex="menu_type_name" key="menu_type_name" />
                <Column title="菜品数量" dataIndex="include_menu_item_count" key="include_menu_item_count" />
                <Column title="涉及职位" dataIndex="relate_position_name" key="relate_position_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            {permission.includes("编辑") && <Button type="primary" onClick={() => {
                                baseAxiosNoInfo('/cooking_center/menu_type/detail', {
                                    params: {
                                        menu_type_id: record.menu_type_id
                                    }
                                }).then((res: any) => {
                                    setID(record.menu_type_id)
                                    setEditVisible(true)

                                    form.setFieldsValue({ menu_type_name: res.menu_type_name, relate_position_number: res.relate_position_number.split(',') })
                                })
                            }}>编辑</Button>}
                        </Space>
                    )}
                />
            </Table>
        </div>

        {/* 膳食中心 -> 菜品管理 -> 菜品分类管理 -> 新增或编辑 */}
        <Modal title={(id ? "编辑" : "添加") + "分类"} visible={editVisible} width={400} footer={false} onCancel={() => { setEditVisible(false) }}>
            <Form {...formItemLayout} form={form} name="basic" onFinish={onFinish} >
                <Form.Item label="菜品分类" name="menu_type_name" rules={[{ required: true, message: '输入分类名称，限6个字内' }, { max: 6, message: '分类名称不能超过6个字' }]} >
                    <Input type="text" />
                </Form.Item>

                <Form.Item label="涉及岗位" name="relate_position_number" rules={[{ required: true, message: '选择涉及岗位' }]} >
                    <Select mode="multiple">
                        {positionsList}
                    </Select>
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}